

//constantes Area Responsable
const AREA_RESP_OBRAS = "ÁREA DE PROYECTOS";// por ahora seguir usando AREA DE PROYECTOS, cuando se cambien todas las hardcoded options usar la constante 
const AREA_RESP_MEJORAS = "ÁREA DE MEJORAS";
const AREA_RESP_MICROCREDITOS = "ÁREA DE MICROCRÉDITOS";
const AREA_RESP_INTERVENCION_SOCIAL = "ÁREA DE INTERVENCIÓN SOCIAL";
const AREA_RESP_CAPACITACIONES = "ÁREA DE CAPACITACIONES";
const AREA_RESP_OTRA = "OTRA";

const ESTADO_ANALISIS_PRELIMINAR = "Análisis preliminar";
const ESTADO_CONFECCION_EXPEDIENTE = "Confección del expediente";

// ============================================================================
// Módulo de visitas (calendario)
// ============================================================================

// Motivos posibles para una visita (desplegable en ModalVisita)
const MOTIVOS_VISITA = [
    "Inauguración",
    "Visita a familias beneficiarias",
    "Visita técnica",
    "Visita de obra",
    "Reunión informativa",
    "Reunión técnica",
    "Reunión legal",
    "Retiro de alimentos",
    "Reunión virtual",
    "Entrega de alimentos",
    "Mesa barrial",
    "Capacitación",
    "Seguimiento de proyecto",
    "Otros",
];

// Colores por área responsable para la grilla del calendario.
// Key = valor guardado en area_responsable (características generales / obras_visitas).
// `hex` se usa como fondo de la visita/celda; `hexDark` para modo oscuro y `texto` para el texto.
const AREA_VISITAS_COLORES = {
    [AREA_RESP_OBRAS]: {                // Área de Obras
        label: "Área de Obras",
        hex: "#B3CEF7",
        hexDark: "#16233c",
        border: "#3B82F6",
    },
    [AREA_RESP_MEJORAS]: {              // Área de Mejoras
        label: "Área de Mejoras",
        hex: "#B5ECC6",
        hexDark: "#16331e",
        border: "#16A34A",
    },
    [AREA_RESP_INTERVENCION_SOCIAL]: {  // Área de Intervención Social
        label: "Área de Intervención Social",
        hex: "#F8C8C8",
        hexDark: "#3b1a1a",
        border: "#DC2626",
    },
    [AREA_RESP_CAPACITACIONES]: {       // Área de Capacitaciones
        label: "Área de Capacitaciones",
        hex: "#90C38A",
        hexDark: "#223a1e",
        border: "#4d7c0f",
    },
    [AREA_RESP_MICROCREDITOS]: {        // Área de Microcréditos
        label: "Área de Microcréditos",
        hex: "#FFE487",
        hexDark: "#3a310f",
        border: "#F59E0B",
    },
    [AREA_RESP_OTRA]: {                 // Otra
        label: "Otra",
        hex: "#D6DBE3",
        hexDark: "#1f2937",
        border: "#6B7280",
    },
};

// Helper: devuelve el color (o default gris) para un area_responsable dado
const colorVisitaPorArea = (area) =>
    AREA_VISITAS_COLORES[area] || AREA_VISITAS_COLORES[AREA_RESP_OTRA];

export {
	AREA_RESP_OBRAS,
	AREA_RESP_MEJORAS,
	AREA_RESP_MICROCREDITOS,
	AREA_RESP_INTERVENCION_SOCIAL,
	AREA_RESP_CAPACITACIONES,
	AREA_RESP_OTRA,
	ESTADO_ANALISIS_PRELIMINAR,
	ESTADO_CONFECCION_EXPEDIENTE,
	MOTIVOS_VISITA,
	AREA_VISITAS_COLORES,
	colorVisitaPorArea
};